import { Popover } from "antd";

export default function CaseStudyClient({ data, setData }) {
	const changeLocation = (
		<div>
			<input
				placeholder="California, USA"
				className="peer h-12 w-full appearance-none rounded-xl border-2 py-2 px-3 font-raleway text-lg leading-tight transition-colors duration-500 focus:border-green-11 focus:outline-none"
				onChange={(e) =>
					setData({
						client: {
							location: e.target.value,
							companySize: data.companySize,
							industry: data.industry,
						},
					})
				}
				value={data.location}
			/>
		</div>
	);

	const changeCompanySize = (
		<div>
			<input
				placeholder="10,000+ employees"
				className="peer h-12 w-full appearance-none rounded-xl border-2 py-2 px-3 font-raleway text-lg leading-tight transition-colors duration-500 focus:border-green-11 focus:outline-none"
				onChange={(e) =>
					setData({
						client: {
							companySize: e.target.value,
							location: data.location,
							industry: data.industry,
						},
					})
				}
				value={data.companySize}
			/>
		</div>
	);

	const changeIndustry = (
		<div>
			<input
				placeholder="Information Technology"
				className="peer h-12 w-full appearance-none rounded-xl border-2 py-2 px-3 font-raleway text-lg leading-tight transition-colors duration-500 focus:border-green-11 focus:outline-none"
				onChange={(e) =>
					setData({
						client: {
							industry: e.target.value,
							companySize: data.companySize,
							location: data.location,
						},
					})
				}
				value={data.industry}
			/>
		</div>
	);
	return (
		<div className="flex flex-col gap-10">
			<h1 className=" font-poppins text-3xl font-extrabold  uppercase md:text-3xl">
				Our Client
			</h1>
			<div className="grid grid-cols-3 gap-5 xl:gap-10">
				<Popover
					content={changeLocation}
					title="Location"
					trigger="click"
					placement="topLeft"
					className=" cursor-pointer"
				>
					<div className="relative col-span-3 overflow-hidden rounded-xl bg-gradient-to-br from-[#4AE4AE] via-green-11 to-green-11 py-4 px-6 shadow-lg md:col-span-1">
						<p className=" font-poppins text-2xl font-bold uppercase text-white">
							Location
						</p>

						<p className=" font-montserrat text-lg text-grey-4">
							{data.location || "Empty"}
						</p>
						<div className="h-16"></div>
						<div className="absolute right-6 -bottom-4 opacity-20">
							<svg
								x="0px"
								y="0px"
								viewBox="0 0 512 512"
								className=" h-28 w-28 -rotate-[25deg] fill-current text-white"
							>
								<path
									d="M256,0C114.508,0,0,114.497,0,256c0,141.492,114.497,256,256,256c141.492,0,256-114.497,256-256
			C512,114.508,397.503,0,256,0z M156.946,52.753c-7.747,21.099-14.25,42.547-19.499,64.295
			c-15.341-4.661-30.432-10.25-45.243-16.762C110.958,80.583,132.812,64.54,156.946,52.753z M72.338,124.24
			c19.171,8.878,38.791,16.3,58.802,22.253c-5.806,30.993-9.126,62.538-9.914,94.507H30.502
			C33.265,198.559,47.728,158.39,72.338,124.24z M72.338,387.76C47.728,353.61,33.265,313.441,30.502,271h90.724
			c0.788,31.969,4.108,63.514,9.914,94.507C111.129,371.46,91.51,378.882,72.338,387.76z M92.204,411.715
			c14.811-6.513,29.901-12.102,45.243-16.762c5.25,21.748,11.752,43.196,19.499,64.295
			C132.824,447.467,110.968,431.427,92.204,411.715z M241,481.498c-15.754-1.025-31.197-3.655-46.135-7.825
			c-11.865-28.12-21.335-56.952-28.398-86.363c24.318-5.437,49.199-8.616,74.533-9.515V481.498z M241,347.777
			c-27.448,0.907-54.405,4.307-80.751,10.175c-5.234-28.529-8.25-57.55-9.013-86.952H241V347.777z M241,241h-89.764
			c0.763-29.402,3.779-58.423,9.013-86.952c26.346,5.868,53.303,9.268,80.751,10.175V241z M241,134.205
			c-25.334-0.899-50.215-4.078-74.533-9.515C173.53,95.279,183,66.447,194.865,38.327c14.938-4.17,30.381-6.8,46.135-7.825V134.205z
			 M439.662,124.24c24.61,34.15,39.073,74.319,41.836,116.76h-90.724c-0.788-31.969-4.108-63.514-9.914-94.507
			C400.871,140.54,420.49,133.118,439.662,124.24z M419.796,100.285c-14.811,6.513-29.901,12.102-45.243,16.762
			c-5.25-21.748-11.752-43.196-19.499-64.295C379.176,64.533,401.032,80.573,419.796,100.285z M271,30.502
			c15.754,1.025,31.197,3.655,46.135,7.825C329,66.447,338.47,95.279,345.533,124.69c-24.318,5.437-49.199,8.616-74.533,9.515
			V30.502z M271,164.223c27.448-0.907,54.405-4.307,80.751-10.175c5.234,28.529,8.25,57.55,9.013,86.952H271V164.223z
			 M317.134,473.672c-14.937,4.171-30.38,6.801-46.134,7.826V377.795c25.334,0.899,50.215,4.078,74.533,9.515
			C338.469,416.721,329,445.553,317.134,473.672z M271,347.777V271h89.764c-0.763,29.402-3.779,58.423-9.013,86.952
			C325.405,352.084,298.448,348.684,271,347.777z M355.054,459.247c7.747-21.099,14.25-42.547,19.499-64.295
			c15.341,4.661,30.432,10.25,45.243,16.762C401.042,431.417,379.188,447.46,355.054,459.247z M439.662,387.76
			c-19.171-8.878-38.791-16.3-58.802-22.253c5.806-30.993,9.126-62.538,9.914-94.507h90.724
			C478.735,313.441,464.272,353.61,439.662,387.76z"
								/>
							</svg>
						</div>
					</div>
				</Popover>

				<Popover
					content={changeCompanySize}
					title="Company Size"
					trigger="click"
					placement="topLeft"
					className=" cursor-pointer"
				>
					<div className="relative col-span-3 overflow-hidden rounded-xl bg-gradient-to-br from-[#4AE4AE] via-green-11 to-green-11 py-4 px-6 shadow-lg md:col-span-1">
						<p className=" font-poppins text-2xl font-bold uppercase text-white">
							Company size
						</p>
						<p className=" font-montserrat text-lg text-grey-4">
							{data.companySize || "Empty"}
						</p>
						<div className="h-16"></div>
						<div className="absolute right-6 -bottom-4 opacity-20">
							<svg
								className=" h-28 w-28 fill-current text-white"
								viewBox="0 0 512 512"
							>
								<path d="m69.064 317.629c4.949-2.475 6.955-8.494 4.48-13.443s-8.494-6.955-13.443-4.48-6.955 8.494-4.48 13.443c2.475 4.95 8.494 6.956 13.443 4.48z" />
								<path d="m512 396.114c0-59.631-48.514-108.144-108.145-108.144-31.5 0-59.895 13.541-79.678 35.104l-38.926-24.523c.51-2.191.789-4.471.789-6.815 0-13.184-8.536-24.405-20.369-28.447v-39.696c13.871-1.235 27.756-5.489 39.633-11.481.531-.217-.481.301 0 0 34.493-18.092 58.84-54.649 58.84-96.226.001-59.631-48.513-108.145-108.144-108.145s-108.144 48.514-108.144 108.145c0 41.586 24.372 78.157 58.877 96.245.49.307-.543-.22 0 0 11.665 5.877 25.305 10.101 38.899 11.4v39.984c-11.49 4.227-19.708 15.283-19.708 28.222 0 2.213.247 4.369.704 6.447l-39.066 24.609c-19.771-21.399-48.054-34.823-79.416-34.823-5.534 0-10.02 4.486-10.02 10.02s4.486 10.02 10.02 10.02c48.582 0 88.106 39.524 88.106 88.105 0 27.915-13.052 52.835-33.37 68.989-.543-13.806-6.169-26.708-15.998-36.533-3.691-3.689-7.82-6.774-12.262-9.233 9.889-7.829 16.251-19.926 16.251-33.488 0-23.549-19.159-42.707-42.707-42.707s-42.711 19.157-42.711 42.706c0 13.562 6.362 25.658 16.249 33.487-4.448 2.462-8.584 5.554-12.281 9.251-9.823 9.836-15.442 22.743-15.978 36.545-20.339-16.153-33.406-41.087-33.406-69.018 0-18.58 6.363-37.414 17.917-53.032 3.291-4.449 2.352-10.723-2.096-14.014-4.449-3.291-10.723-2.352-14.014 2.096-14.088 19.043-21.846 42.11-21.846 64.95 0 41.587 24.372 78.158 58.878 96.246.49.307-.542-.22 0 0 14.594 7.353 31.84 11.899 49.266 11.899 17.447 0 34.698-4.55 49.305-11.919.532-.217-.481.301 0 0 34.493-18.092 58.84-54.649 58.84-96.226 0-21.049-6.051-40.709-16.496-57.343l37.427-23.576c5.147 4.125 11.669 6.6 18.762 6.6 6.958 0 13.365-2.383 18.465-6.366l37.561 23.662c-10.322 16.566-16.296 36.108-16.296 57.023 0 41.586 24.372 78.157 58.877 96.245.491.308-.543-.22 0 0 14.593 7.352 31.841 11.9 49.267 11.9 17.448 0 34.696-4.548 49.303-11.918.529-.216-.479.299 0 0 34.495-18.092 58.841-54.648 58.841-96.227zm-403.837-32.933c12.5 0 22.668 10.169 22.668 22.668s-10.169 22.668-22.668 22.668-22.668-10.169-22.668-22.668 10.168-22.668 22.668-22.668zm-34.731 113.906v-9.781c0-9.27 3.612-17.992 10.167-24.554 6.563-6.563 15.279-10.177 24.548-10.177h.015c9.273 0 17.993 3.611 24.554 10.168 6.564 6.561 10.179 15.284 10.179 24.563v9.764c-10.668 4.597-22.416 7.149-34.75 7.149-12.32.001-24.056-2.545-34.713-7.132zm182.586-348.797c-12.499 0-22.668-10.169-22.668-22.668s10.169-22.668 22.668-22.668c12.5 0 22.669 10.169 22.669 22.668s-10.169 22.668-22.669 22.668zm-.016 24.057h.015c9.273 0 17.993 3.611 24.553 10.168 6.564 6.561 10.179 15.284 10.179 24.563v9.764c-10.668 4.597-22.416 7.148-34.75 7.148-12.32 0-24.055-2.546-34.713-7.133v-9.78c0-9.27 3.612-17.992 10.167-24.555 6.563-6.561 15.28-10.175 24.549-10.175zm-88.107-36.461c0-48.582 39.524-88.106 88.105-88.106s88.106 39.524 88.106 88.106c0 27.914-13.052 52.835-33.371 68.989-.543-13.806-6.169-26.708-15.998-36.533-3.69-3.689-7.82-6.774-12.262-9.233 9.889-7.829 16.251-19.926 16.251-33.489 0-23.549-19.159-42.707-42.708-42.707s-42.707 19.159-42.707 42.707c0 13.562 6.361 25.658 16.249 33.487-4.448 2.462-8.584 5.554-12.28 9.25-9.824 9.836-15.443 22.743-15.979 36.545-20.339-16.152-33.406-41.085-33.406-69.016zm78.067 175.85c0-5.525 4.495-10.02 10.02-10.02s10.019 4.495 10.019 10.02-4.494 10.02-10.019 10.02-10.02-4.495-10.02-10.02zm69.788 104.378c0-48.581 39.523-88.105 88.105-88.105s88.106 39.524 88.106 88.105c0 27.915-13.052 52.835-33.371 68.99-.543-13.806-6.169-26.709-15.998-36.533-3.69-3.689-7.82-6.774-12.262-9.233 9.888-7.829 16.251-19.926 16.251-33.488 0-23.549-19.159-42.707-42.707-42.707s-42.707 19.159-42.707 42.707c0 13.562 6.362 25.658 16.249 33.487-4.448 2.462-8.584 5.554-12.281 9.251-9.824 9.836-15.443 22.743-15.979 36.545-20.339-16.154-33.406-41.088-33.406-69.019zm88.124 12.404c-12.499 0-22.668-10.169-22.668-22.668s10.169-22.668 22.668-22.668 22.668 10.169 22.668 22.668-10.169 22.668-22.668 22.668zm-34.732 68.569v-9.78c0-9.27 3.613-17.991 10.167-24.554 6.563-6.563 15.279-10.177 24.548-10.177h.015c9.274 0 17.994 3.611 24.554 10.168 6.565 6.561 10.179 15.284 10.179 24.563v9.764c-10.668 4.597-22.416 7.148-34.75 7.148-12.32.001-24.055-2.545-34.713-7.132z" />
							</svg>
						</div>
					</div>
				</Popover>

				<Popover
					content={changeIndustry}
					title="Industry"
					trigger="click"
					placement="topLeft"
					className=" cursor-pointer"
				>
					<div className="relative col-span-3 overflow-hidden rounded-xl bg-gradient-to-br from-[#4AE4AE] via-green-11 to-green-11 py-4 px-6 shadow-lg md:col-span-1">
						<p className=" font-poppins text-2xl font-bold uppercase text-white">
							Industry
						</p>
						<p className=" font-montserrat text-lg text-grey-4">
							{data.industry || "Empty"}
						</p>
						<div className="h-16"></div>
						<div className="absolute right-6 -bottom-4 opacity-20">
							<svg
								className=" h-28 w-28 fill-current text-white"
								viewBox="0 0 512 512"
							>
								<g>
									<path d="M472,128H461.61a72,72,0,1,0-107.22,0H256V48a8,8,0,0,0-8-8H216a8,8,0,0,0-8,8v80h-8V16a8,8,0,0,0-8-8H160a8,8,0,0,0-8,8V128h-8V72a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H40A32.036,32.036,0,0,0,8,160V400a32.036,32.036,0,0,0,32,32H204.9l-10.67,32H168a8,8,0,0,0-8,8v16H80a8,8,0,0,0,0,16H432a8,8,0,0,0,0-16H352V472a8,8,0,0,0-8-8H317.77L307.1,432H472a32.036,32.036,0,0,0,32-32V160A32.036,32.036,0,0,0,472,128ZM416,24.58A56.11,56.11,0,0,1,463.42,72H416ZM411.31,88h52.11a55.962,55.962,0,0,1-88.94,36.83ZM352,80a56.086,56.086,0,0,1,48-55.42V76.69l-36.83,36.83A55.708,55.708,0,0,1,352,80ZM224,56h16V208H224Zm-24,88h8v64h-8ZM168,24h16V208H168ZM144,144h8v64h-8ZM112,80h16V208H112ZM336,480v8H176v-8ZM211.1,464l10.67-32h68.46l10.67,32ZM488,400a16.021,16.021,0,0,1-16,16H40a16.021,16.021,0,0,1-16-16V384H488Zm0-32H24V160a16.021,16.021,0,0,1,16-16H96v64H88V160a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8v56a8,8,0,0,0,8,8H304a8,8,0,0,0,8-8V160a8,8,0,0,0-8-8H272a8,8,0,0,0-8,8v48h-8V144H375.08a71.733,71.733,0,0,0,65.84,0H472a16.021,16.021,0,0,1,16,16ZM72,168v40H56V168Zm208,40V168h16v40Z" />
									<path d="M96,392H48a8,8,0,0,0,0,16H96a8,8,0,0,0,0-16Z" />
									<path d="M128,392h-8a8,8,0,0,0,0,16h8a8,8,0,0,0,0-16Z" />
									<path d="M344,208a7.974,7.974,0,0,0,5.657-2.343L379.313,176H448a8,8,0,0,0,0-16H376a8,8,0,0,0-5.657,2.343l-32,32A8,8,0,0,0,344,208Z" />
									<path d="M448,296a24,24,0,0,0-20.75,11.97L343.5,259.11a24,24,0,0,0-47.11.6l-84.28,63.21a23.979,23.979,0,0,0-41.48,2.18l-83.3-34.71a24.01,24.01,0,1,0-1.96,16.51l83.3,34.71a23.995,23.995,0,0,0,46.94-1.32l84.28-63.21a23.973,23.973,0,0,0,40.86-1.05l83.75,48.86A24,24,0,1,0,448,296Zm-376,.04a8.02,8.02,0,1,1,0-.04ZM192,344a8.011,8.011,0,0,1-8-8v-.04a8,8,0,1,1,8,8.04Zm128-72a8,8,0,1,1,8-8A8.011,8.011,0,0,1,320,272Zm128,56a8,8,0,1,1,8-8A8.011,8.011,0,0,1,448,328Z" />
									<path d="M384,344H328a8,8,0,0,0,0,16h56a8,8,0,0,0,0-16Z" />
									<path d="M384,320H360a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16Z" />
									<path d="M48,248h88a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16Z" />
									<path d="M160,248h8a8,8,0,0,0,0-16h-8a8,8,0,0,0,0,16Z" />
								</g>
							</svg>
						</div>
					</div>
				</Popover>
			</div>
		</div>
	);
}
